
import axios from 'axios'
const state = {
  notifications: [],
}
import config from '@/../config'

const defaultErrorHandler = (error =>  Promise.reject(error.response))

const mutations = {
	SET_NOTIFICATIONS (state, payload) {
		state.notifications = payload
	},
	MARK_NOTIFICATION_AS_READ (state, payload) {
		state.notifications
			.find(item => item.id == payload.id)
			.visualizada = true
	},
	BULK_MARK_NOTIFICATION_AS_READ (state, payload) {
		payload.forEach(notification => {
			state.notifications
				.find(item => item.id == notification.id)
				.visualizada = true
		})
	},
}

const actions = {
	GET_NOTIFICATIONS ({commit}, payload) {
		return axios.get(config.apiUrl + config.versoes[0]+ '/notificacoes')
		.then(response => {
			if(response.data) {
				response.data.sort((a, b) =>
					+new Date(b.data) - +new Date(a.data)
				)
			}
			commit('SET_NOTIFICATIONS', response.data)
			return response.data
		})
		.catch(error => {
			return Promise.reject(error.response);
		})
	},

	async PATCH_NOTIFICATION_AS_READ ({commit}, payload) {
		let response = await axios.patch(config.apiUrl + config.versoes[0]+ `/notificacoes/${payload.id}`, {
			visualizada: true
		})
		commit('MARK_NOTIFICATION_AS_READ', {id: payload.id})
 		return response.data
	},
	async BULK_PATCH_NOTIFICATION_AS_READ ({commit}, payload) {
		let response = await axios.put(config.apiUrl + config.versoes[0]+ `/notificacoes/`, payload)
		commit('BULK_MARK_NOTIFICATION_AS_READ', payload)
 		return response.data
	},
	async DELETE_NOTIFICATIONS ({commit}, payload) {
		let response = await axios.delete(config.apiUrl + config.versoes[0]+ `/notificacoes/`, {data: payload})
 		return response.data
	},
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js